import { TextField, styled } from '@mui/material';
import { colors } from '@themes/colors';

export const StyledTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    '&.Mui-disabled, &.Mui-readOnly': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
      '.MuiOutlinedInput-input': {
        WebkitTextFillColor: colors.text.primary,
      },
    },
  },
  '& .MuiFormLabel-root.Mui-disabled, & .MuiFormLabel-root.Mui-readOnly': {
    color: colors.text.secondary,
    backgroundColor: 'transparent',
  },
  '& .Mui-disabled, & .Mui-readOnly': {
    backgroundColor: colors.background.disabled,
    borderRadius: '4px',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: colors.text.secondary,
  },
  '& .MuiInputBase-input': {
    boxSizing: 'border-box',
  },
  '& legend span': {
    display: 'none',
  },
}));

export const StyledTextarea = styled(TextField)(() => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    padding: '0 !important',
    height: 'auto',
    '&.Mui-disabled, &.Mui-readOnly': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
      '.MuiOutlinedInput-input': {
        WebkitTextFillColor: colors.text.primary,
      },
    },
  },
  '& .MuiFormLabel-root.Mui-disabled, & .MuiFormLabel-root.Mui-readOnly': {
    color: colors.text.secondary,
    backgroundColor: 'transparent',
  },
  '& .Mui-disabled, & .Mui-readOnly': {
    backgroundColor: colors.background.disabled,
    borderRadius: '4px',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: colors.text.secondary,
  },
}));
